module.exports = "//cdn.mxpnl.com/static/asset-cache/b3b9b8a735ffff28bcc7e9119062b0e9/iron/common/assets/images/charts/funnel-frequency.svg";